import { util } from '../util'
export const payload = {
    dashboardPromos: status => ({
        pageNo: 1,
        search: {
            status: [status],
        },
        size: 5,
        sort: { start_date: 'asc' },
    }),
    dashboardNotifications: status => ({
        pageNo: 1,
        search: {
            status: [status],
            start_date: util.getCurrentISODate(),
        },
        size: 5,
        sort: { start_date: 'asc' },
    }),
    regionFilterQuery: function ({ value, list, post_value, baseFilterList }) {
        let { state = [], country = [] } = post_value || {}
        const suggestedList = value.length ? util.searchByInput(value, baseFilterList) : []
        const uniqueStateList = new Set([...list, ...suggestedList])
        const stateCodes = util.getStateCodeFromValue(uniqueStateList)
        state = [...stateCodes]

        if (list.includes('National (US)')) {
            country = country.includes('US') ? country : country.concat(['US'])
        }
        if (list.includes('National (CA)')) {
            country = country.includes('CA') ? country : country.concat(['CA'])
        }
        if (list.includes('Any US States')) {
            country.push('US')
        }
        return state.length || country.length
            ? {
                  ...(state.length ? { state } : null),
                  ...(country.length ? { country } : null),
              }
            : null
    },
}
